import {newsContentManager} from '../../../api/newsContentManager';

import EventItemDto from '../../../api/eventItemDto';
import NewsCategory from '../../../api/newsCategoryEntity';
import { notifyBreadcrumChangeAction } from '../../../common/components/breadcrumb/actions/notifyBreadcrumChange';
import { actionTypes } from '../../../common/constants/actionTypes';

import { httpCallStartAction } from '../../../middlewares/http/actions';

export const fetchArchiveEventItemsAction = (query?: object) => (dispatch: any) => {
    dispatch(httpCallStartAction());
    
    newsContentManager.fetchEventsItemsAsync(query)
    .then((eventItems) => {
      dispatch(fetchArchiveEventItemsCompleted(eventItems));
      dispatch(notifyBreadcrumChangeAction(actionTypes.BREADCRUMB_CHANGED_ON_ARCHIVE_PAGE, "Tapahtuma-arkisto"));
    });
};

export const fetchEventCategoriesAction = () => (dispatch: any) => {
    dispatch(httpCallStartAction());
  
  newsContentManager.fetchEventCategoriesAsync()
    .then((newsCategories) => {
      dispatch(fetchEventCategoriesCompleted(newsCategories));
      dispatch(notifyBreadcrumChangeAction(actionTypes.BREADCRUMB_CHANGED_ON_ARCHIVE_PAGE, "Uutisarkisto"));
    });
  };

export const fetchArchivePageNewsItemsByCategoryAction = (categories: string, query?: object) => (dispatch: any) => {
    dispatch(httpCallStartAction());
  
  newsContentManager.fetchEventItemsByCategoryAsync(categories, query)
    .then((eventItems) => {
      dispatch(fetchArchiveEventItemsCompleted(eventItems));
        dispatch(notifyBreadcrumChangeAction(actionTypes.BREADCRUMB_CHANGED_ON_ARCHIVE_PAGE, "Tapahtuma-arkisto"));
    })
    .catch(error => dispatch(handleError(error)));;
  };

  const fetchEventCategoriesCompleted = (newsCategories: NewsCategory[]) => ({
    meta: {
        httpEnd: true,
      },
    payload: newsCategories,
    type: actionTypes.FETCH_EVENT_CATEGORIES_COMPLETED
  });
  
const fetchArchiveEventItemsCompleted = (eventItems: EventItemDto) => ({
    meta: {
        httpEnd: true,
      },
    payload: eventItems,
    type: actionTypes.FETCH_EVENT_ITEMS
});

const handleError = (reason: any) => ({
    meta: {
        httpEnd: true,
      },
    payload: {message: reason.message, hasError: true},
    type: actionTypes.FETCH_CONTENT_PAGE_ERROR
  });


// WEBPACK FOOTER //
// ./src/components/eventsArchivePage/actions/fetchArchivePageEventItems.ts